import { IdQuickSkip } from "../features/quick-skip-dialog/IdQuickSkip";
var UtilQuickSkip = /** @class */ (function () {
    function UtilQuickSkip() {
        this.getProcessRemainingTimestamp = function (building, processToQuickSkip) {
            if (!building) {
                return 0;
            }
            if (processToQuickSkip === IdQuickSkip.Production) {
                var production = building.production.production;
                return production.remainingTime || 0;
            }
            return building.proto.remainingTime || 0;
        };
    }
    return UtilQuickSkip;
}());
export var utilQuickSkip = new UtilQuickSkip();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilQuickSkip.ts
// module id = 954
// module chunks = 3